import React from 'react'
import '../styles/activeCallList-filter'

class ResetButton extends React.Component {
    render() {
        const { className, filter, onChange } = this.props

        return (
            <button onClick={() => onChange("")} className="btn btn-default reset">Reset</button>
        )
    }
}

export default ResetButton



// WEBPACK FOOTER //
// ./components/ResetButton.jsx